export default __webpack_public_path__ + "static/media/avatarman1.8ddc77c3.png";